export default __webpack_public_path__ + "separator.3504309c.svg";